import AuthAPI from '@/features/api/auth/auth'
import LicenceAPI from '@/features/api/licence/licence'
import OAuthAPI from '@/features/api/oauth/oauth'
import TerminalAPI from '@/features/api/terminal/terminal'

export const setAllApisHostUrl = (url: string) => {
    AuthAPI.setHostUrl(url)
    LicenceAPI.setHostUrl(url)
    OAuthAPI.setHostUrl(url)
    TerminalAPI.setHostUrl(url)
}
